import { BusinessType } from 'types'

const CDN = 'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto,c_fill,w_1280,h_900'

const FALLBACK_BEFORE = `${CDN}/v1775481604/onboarding_assets/thumbnail_wxes65.png`

export const BEFORE_IMAGES: Partial<Record<BusinessType, string>> = {
  product: `${CDN}/v1775752072/onboarding_assets/visual_styles_examples/product_before.jpg`,
  place: `${CDN}/v1775752065/onboarding_assets/visual_styles_examples/place_before.jpg`,
  service: `${CDN}/v1775748056/onboarding_assets/visual_styles_examples/service_before.jpg`,
}

// im listing these as human readable instead of the VS id just for my sanity
export const AFTER_IMAGES: Partial<Record<string, Partial<Record<BusinessType, string>>>> = {
  'hero shot': {
    product: `${CDN}/v1775751965/onboarding_assets/visual_styles_examples/product_hero_shot.jpg`,
    place: `${CDN}/v1775751958/onboarding_assets/visual_styles_examples/place_hero_shot.jpg`,
    service: `${CDN}/v1775747798/onboarding_assets/visual_styles_examples/service_hero_shot.jpg`,
  },
  'disposable camera': {
    product: `${CDN}/v1775751970/onboarding_assets/visual_styles_examples/product_disposable_camera.jpg`,
    place: `${CDN}/v1775751962/onboarding_assets/visual_styles_examples/place_disposable_camera.jpg`,
    service: `${CDN}/v1775747809/onboarding_assets/visual_styles_examples/service_disposable_camera.jpg`,
  },
  'negative edge': {
    product: `${CDN}/v1775751976/onboarding_assets/visual_styles_examples/product_negative_edge.jpg`,
    place: `${CDN}/v1775751967/onboarding_assets/visual_styles_examples/place_negative_edge.jpg`,
    service: `${CDN}/v1775747821/onboarding_assets/visual_styles_examples/service_negative_edge.jpg`,
  },
  'amber shadow': {
    product: `${CDN}/v1775751979/onboarding_assets/visual_styles_examples/product_amber_shadow.jpg`,
    place: `${CDN}/v1775751976/onboarding_assets/visual_styles_examples/place_amber_shadow.jpg`,
    service: `${CDN}/v1775747838/onboarding_assets/visual_styles_examples/service_amber_shadow.jpg`,
  },
  'retro frame': {
    product: `${CDN}/v1775751983/onboarding_assets/visual_styles_examples/product_retro_frame.jpg`,
    place: `${CDN}/v1775751983/onboarding_assets/visual_styles_examples/place_retro_frame.jpg`,
    service: `${CDN}/v1775747853/onboarding_assets/visual_styles_examples/service_retro_frame.jpg`,
  },
  'saturated film': {
    product: `${CDN}/v1775751987/onboarding_assets/visual_styles_examples/product_saturated_film.jpg`,
    place: `${CDN}/v1775751989/onboarding_assets/visual_styles_examples/place_saturated_film.jpg`,
    service: `${CDN}/v1775747867/onboarding_assets/visual_styles_examples/service_saturated_film.jpg`,
  },
  'indigo dusk': {
    product: `${CDN}/v1775751990/onboarding_assets/visual_styles_examples/product_indigo_dusk.jpg`,
    place: `${CDN}/v1775751996/onboarding_assets/visual_styles_examples/place_indigo_dusk.jpg`,
    service: `${CDN}/v1775747874/onboarding_assets/visual_styles_examples/service_indigo_dusk.jpg`,
  },
  'electric pulse': {
    product: `${CDN}/v1775751994/onboarding_assets/visual_styles_examples/product_electric_pulse.jpg`,
    place: `${CDN}/v1775752005/onboarding_assets/visual_styles_examples/place_electric_pulse.jpg`,
    service: `${CDN}/v1775747884/onboarding_assets/visual_styles_examples/service_electric_pulse.jpg`,
  },
  'sun-drenched': {
    product: `${CDN}/v1775751998/onboarding_assets/visual_styles_examples/product_sun_drenched.jpg`,
    place: `${CDN}/v1775752011/onboarding_assets/visual_styles_examples/place_sun_drenched.jpg`,
    service: `${CDN}/v1775747899/onboarding_assets/visual_styles_examples/service_sun_drenched.jpg`,
  },
  'golden hour': {
    product: `${CDN}/v1775752004/onboarding_assets/visual_styles_examples/product_golden_hour.jpg`,
    place: `${CDN}/v1775752019/onboarding_assets/visual_styles_examples/place_golden_hour.jpg`,
    service: `${CDN}/v1775747911/onboarding_assets/visual_styles_examples/service_golden_hour.jpg`,
  },
  'classic mono': {
    product: `${CDN}/v1775752011/onboarding_assets/visual_styles_examples/product_classic_mono.jpg`,
    place: `${CDN}/v1775752024/onboarding_assets/visual_styles_examples/place_classic_mono.jpg`,
    service: `${CDN}/v1775747929/onboarding_assets/visual_styles_examples/service_classic_mono.jpg`,
  },
  'executive warmth': {
    product: `${CDN}/v1775752016/onboarding_assets/visual_styles_examples/product_executive_warmth.jpg`,
    place: `${CDN}/v1775752029/onboarding_assets/visual_styles_examples/place_executive_warmth.jpg`,
    service: `${CDN}/v1775747957/onboarding_assets/visual_styles_examples/service_executive_warmth.jpg`,
  },
  'amber glow': {
    product: `${CDN}/v1775752022/onboarding_assets/visual_styles_examples/product_amber_glow.jpg`,
    place: `${CDN}/v1775752032/onboarding_assets/visual_styles_examples/place_amber_glow.jpg`,
    service: `${CDN}/v1775747971/onboarding_assets/visual_styles_examples/service_amber_glow.jpg`,
  },
  'night owl': {
    product: `${CDN}/v1775752030/onboarding_assets/visual_styles_examples/product_night_owl.jpg`,
    place: `${CDN}/v1775752036/onboarding_assets/visual_styles_examples/place_night_owl.jpg`,
    service: `${CDN}/v1775747987/onboarding_assets/visual_styles_examples/service_night_owl.jpg`,
  },
  'high bloom': {
    product: `${CDN}/v1775752035/onboarding_assets/visual_styles_examples/product_high_bloom.jpg`,
    place: `${CDN}/v1775752041/onboarding_assets/visual_styles_examples/place_high_bloom.jpg`,
    service: `${CDN}/v1775748002/onboarding_assets/visual_styles_examples/service_high_bloom.jpg`,
  },
  'day one': {
    product: `${CDN}/v1775752041/onboarding_assets/visual_styles_examples/product_day_one.jpg`,
    place: `${CDN}/v1775752045/onboarding_assets/visual_styles_examples/place_day_one.jpg`,
    service: `${CDN}/v1775748017/onboarding_assets/visual_styles_examples/service_day_one.jpg`,
  },
  'cyan crisp': {
    product: `${CDN}/v1775752048/onboarding_assets/visual_styles_examples/product_cyan_crisp.jpg`,
    place: `${CDN}/v1775752048/onboarding_assets/visual_styles_examples/place_cyan_crisp.jpg`,
    service: `${CDN}/v1775748027/onboarding_assets/visual_styles_examples/service_cyan_crisp.jpg`,
  },
  'deep contrast': {
    product: `${CDN}/v1775752057/onboarding_assets/visual_styles_examples/product_deep_contrast.jpg`,
    place: `${CDN}/v1775752053/onboarding_assets/visual_styles_examples/place_deep_contrast.jpg`,
    service: `${CDN}/v1775748034/onboarding_assets/visual_styles_examples/service_deep_contrast.jpg`,
  },
  'dramatic luxe': {
    product: `${CDN}/v1775752063/onboarding_assets/visual_styles_examples/product_dramatic_luxe.jpg`,
    place: `${CDN}/v1775752056/onboarding_assets/visual_styles_examples/place_dramatic_luxe.jpg`,
    service: `${CDN}/v1775748042/onboarding_assets/visual_styles_examples/service_dramatic_luxe.jpg`,
  },
  'gauzy portrait': {
    product: `${CDN}/v1775752068/onboarding_assets/visual_styles_examples/product_gauzy_portrait.jpg`,
    place: `${CDN}/v1775752060/onboarding_assets/visual_styles_examples/place_gauzy_portrait.jpg`,
    service: `${CDN}/v1775748050/onboarding_assets/visual_styles_examples/service_gauzy_portrait.jpg`,
  },
}

export function getBeforeImage(businessType?: BusinessType | null): string {
  return (businessType && BEFORE_IMAGES[businessType]) ?? FALLBACK_BEFORE
}

export function getAfterImage(styleName: string, businessType?: BusinessType | null): string | undefined {
  return businessType ? AFTER_IMAGES[styleName.toLowerCase().trim()]?.[businessType] : undefined
}
